// Fluent UI v9 theme from the 3Seven palette (brand/tokens.json). The brand ramp runs through
// DARK (60), DUSK (80, Fluent's primary) and RAIN (120). Web type is Nunito Sans (style guide §4).

import { createLightTheme, type BrandVariants, type Theme } from "@fluentui/react-components";

export const palette = {
  dark: "#2B3C4D",
  dusk: "#46576F",
  rain: "#8C97A8",
  sky: "#88B1C9",
  dawn: "#941100",
  sea: "#007F7F",
  mist: "#E7E6E6",
  white: "#FFFFFF",
} as const;

const ramp: BrandVariants = {
  10: "#0B1016",
  20: "#121A23",
  30: "#18222E",
  40: "#1E2B39",
  50: "#243444",
  60: "#2B3C4D",
  70: "#36485D",
  80: "#46576F",
  90: "#56677E",
  100: "#67788D",
  110: "#7A8A9E",
  120: "#8C97A8",
  130: "#A2ADBB",
  140: "#B8C1CD",
  150: "#D0D7DF",
  160: "#E8ECF0",
};

const font = "'Nunito Sans', 'Avenir Next LT Pro', 'Avenir Next', Avenir, 'Segoe UI', system-ui, sans-serif";

export const theme: Theme = {
  ...createLightTheme(ramp),
  fontFamilyBase: font,
  fontWeightRegular: 300,
  fontWeightSemibold: 600,
  colorNeutralForeground1: palette.dark,
};
